export default __webpack_public_path__ + "static/media/congrats-emoji.755d5a19.png";